import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'loanPurpose',
    label: 'Loan Purpose',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyType',
    label: 'Property Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'purchasePrice',
    label: 'Purchase Price',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'helocPurpose',
    label: 'Purpose of Subordinate Financing',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanAmount',
    label: 'Loan Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'leadSourceId',
    label: 'Lead Source',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'refinancePurpose',
    label: 'Purpose Of Refinance',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanCashOutAmount',
    label: 'Cash Out Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'propertyValue',
    label: 'Property Value',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'loanDownPayment',
    label: 'Down Payment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const leadLoanInformationForm = {
  name: FormNames.LEAD,
  label: 'Loan Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
